import {
  Dialog,
  DialogContent,
  Slide,
} from '@mui/material';
import DialogHeader from "./dialog-header";
import { forwardRef } from 'react';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const ReportDialog = (props) => {
  return (
    <Dialog
      aria-labelledby="dialog-title"
      open={props.open}
      fullWidth={false}
      maxWidth={false}
      TransitionComponent={Transition}
      TransitionProps={{ timeout: 500 }}
      classes={{ paper: `${props.classes} dialog-layout` }}
      fullScreen={props.fullScreen}
      scroll="paper"
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '600px',
          minWidth: '40vw',
          margin: 0,
          position: 'fixed',
          right: 8,
          top: '30px',
          height: '100vh',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      }}
    >
      <DialogHeader disable={props.isDisabled} title={props.title} onClose={props.onClose} text={props.text} />

      <DialogContent
        classes={{ root: "dialog-content" }}
        sx={{
          flex: '1 1 auto',
          overflow: 'auto',
          padding: 0,
        }}
      >
        {props.content}
      </DialogContent>
    </Dialog>
  );
};

export default ReportDialog;
